/** Components **/
import TableHeaderTitleWithPicto from './../../../components/Table/TableHeaders/TitleWithPicto';
import TableCellKDifficulty from './../../../components/Table/TableCells/KDifficulty';
import DefaultRangeFilterToolTip from './../../../components/Table/FilterToolTips/DefaultRangeFilterToolTip';

export const KDifficultyColumn = ( widthColumns ) => 
{
  return {
    accessor: "kdifficulty",
    width: widthColumns["kdifficulty"],
    title: "k. diffic.",
    className: "col-decisions",
    Filter: DefaultRangeFilterToolTip,
    filter: 'multiFieldsCustomFilter',
    filterTitle: "Filtrer par actions",
    sortDescFirst: true,
    sortType: 'valueSort',
    Header: props => 
      <TableHeaderTitleWithPicto 
        id={props.column.id} 
        title={props.column.title} 
      />,
    Total: '',
    Cell: props => 
      <TableCellKDifficulty values={props.cell.row.values.kdifficulty} />
  }
}